import type { SitePackageId } from "@enrein/shared-contracts";
import type { PackageEligibilityBlocked } from "../../studio-shared/workflow/studio-workflow.js";
import { sitePackageDisplayLabel } from "../../studio-shared/site-package-labels.js";
import { V10Btn } from "./V10Primitives.js";

function splitJoinedReasons(value: string | undefined): readonly string[] {
  if (typeof value !== "string" || value.trim().length === 0) return [];
  return value
    .split(";")
    .map((part) => part.trim())
    .filter((part) => part.length > 0);
}

function dedupeReasons(block: PackageEligibilityBlocked["block"]): readonly string[] {
  const parts = [
    ...splitJoinedReasons(block.packageRequiredFieldBlockReason),
    block.richnessBlockReason,
    ...block.hardBlockers,
    ...block.missingRequirements,
    ...block.warnings,
  ].filter((part): part is string => typeof part === "string" && part.trim().length > 0);
  return [...new Set(parts)];
}

export function V10PackageEligibilityCard({
  blocked,
  busy,
  onBuildFallback,
  onEnrichProfile,
}: {
  readonly blocked: PackageEligibilityBlocked;
  readonly busy: boolean;
  readonly onBuildFallback: (packageId: SitePackageId) => void;
  readonly onEnrichProfile: () => void;
}) {
  const requestedLabel = sitePackageDisplayLabel(blocked.requestedPackage);
  const fallbackLabel = blocked.suggestedFallbackPackage
    ? sitePackageDisplayLabel(blocked.suggestedFallbackPackage)
    : null;
  const reasons = dedupeReasons(blocked.block);

  return (
    <section className="v10-panel-block v10-eligibility-card" aria-label="Package eligibility">
      <p className="v10-cl-kicker">Package eligibility</p>
      <p className="v10-validation">
        <strong>{requestedLabel}</strong> ke liye profile abhi ready nahi.
      </p>
      {reasons.length > 0 ? (
        <>
          <p className="v10-muted">Kyun:</p>
          <ul className="v10-validation-list">
            {reasons.map((reason) => (
              <li key={reason}>{reason}</li>
            ))}
          </ul>
        </>
      ) : null}
      {typeof blocked.block.richnessScore === "number" &&
      typeof blocked.block.minimumRichnessRequired === "number" ? (
        <p className="v10-muted">
          Richness score {blocked.block.richnessScore} — minimum {blocked.block.minimumRichnessRequired}{" "}
          required for {requestedLabel}.
        </p>
      ) : null}
      <p className="v10-muted">Do options:</p>
      <div className="v10-hero-actions">
        {blocked.suggestedFallbackPackage && fallbackLabel ? (
          <V10Btn
            variant="primary"
            disabled={busy}
            onClick={() => onBuildFallback(blocked.suggestedFallbackPackage!)}
          >
            Build {fallbackLabel}
          </V10Btn>
        ) : null}
        <V10Btn variant="gold" disabled={busy} onClick={onEnrichProfile}>
          Enrich profile for {requestedLabel}
        </V10Btn>
      </div>
    </section>
  );
}
